import "../stylesheets/Header.css";

import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";

import ScreenManager from "../manager/ScreenManager";
import Button from "react-bootstrap/Button";

const screenManager = ScreenManager.instance;

export default class Header extends React.Component {

    // title of the current screen (the screen this header belongs to)
    title = screenManager.getScreenTitleByRouteName( screenManager.currentRouteName );

    render() {

        // the div is used as spacer with identical size as the fixed header
        return (
            <>
                <div className="navbar navbar-expand"><div className="navbar-nav" ><div className="navbar-brand" >.</div> </div></div>

                <Navbar fixed="top" className="noBorder justifySpaceBetween primaryTheme" >

                    { screenManager.canPop && <Button variant="dark" onClick={() => screenManager.popScreen()} >{"< zurück"}</Button> }

                    <Nav>
                        <Navbar.Brand id="headerTitle">{this.props.title || this.title}</Navbar.Brand>
                        {this._renderScreenIcons()}
                    </Nav>

                    <Form className="primaryFontColor" inline>
                        {this.props.children}
                    </Form>

                </Navbar>
            </>
        );
        
    }

    _renderScreenIcons() {
        return screenManager.screensWithTitle.map( screen => {

            var cmp;
            const currentlySelected = screen.routeName === screenManager.currentRouteName;

            cmp = <screen.icon.component />;

            return (
                
                <Nav.Link
                    active={currentlySelected}
                    onSelect={() => !currentlySelected && screenManager.changeScreen( screen.routeName )}
                    eventKey={"Link:"+screen.routeName}
                    key={"HeaderLink:"+screen.routeName}
                >
                    {cmp}
                    {" " + screen.navTitle}
                </Nav.Link>
                
            );

        });
    }

}